export const FAMILYCONTACTTYPE_LOADING = "FAMILYCONTACTTYPE_LOADING";
export const FAMILYCONTACTTYPE_RESET = "FAMILYCONTACTTYPE_RESET";
export const GET_FAMILYCONTACTTYPE = "GET_FAMILYCONTACTTYPE";
export const GET_FAMILYCONTACTTYPE_SUCCESS = "GET_FAMILYCONTACTTYPE_SUCCESS";
export const GET_FAMILYCONTACTTYPE_FAIL = "GET_FAMILYCONTACTTYPE_FAIL";
export const DELETE_FAMILYCONTACTTYPE = "DELETE_FAMILYCONTACTTYPE"
export const DELETE_FAMILYCONTACTTYPE_SUCCESS = "DELETE_FAMILYCONTACTTYPE_SUCCESS"
export const DELETE_FAMILYCONTACTTYPE_FAIL = "DELETE_FAMILYCONTACTTYPE_FAIL"
export const UPDATE_FAMILYCONTACTTYPE = "UPDATE_FAMILYCONTACTTYPE"
export const UPDATE_FAMILYCONTACTTYPE_SUCCESS = "UPDATE_FAMILYCONTACTTYPE_SUCCESS"
export const UPDATE_FAMILYCONTACTTYPE_FAIL = "UPDATE_FAMILYCONTACTTYPE_FAIL"
export const ADD_NEW_FAMILYCONTACTTYPE = "ADD_NEW_FAMILYCONTACTTYPE"
export const ADD_FAMILYCONTACTTYPE_SUCCESS = "ADD_FAMILYCONTACTTYPE_SUCCESS"
export const ADD_FAMILYCONTACTTYPE_FAIL = "ADD_FAMILYCONTACTTYPE_FAIL"